import { render, staticRenderFns } from "./MListSimple.vue?vue&type=template&id=242d2fbd&"
import script from "./MListSimple.vue?vue&type=script&lang=js&"
export * from "./MListSimple.vue?vue&type=script&lang=js&"
import style0 from "./MListSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242d2fbd')) {
      api.createRecord('242d2fbd', component.options)
    } else {
      api.reload('242d2fbd', component.options)
    }
    module.hot.accept("./MListSimple.vue?vue&type=template&id=242d2fbd&", function () {
      api.rerender('242d2fbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MListSimple.vue"
export default component.exports